import CisCalculation from './pages/CisCalculation';
import PublicCalculation from './pages/PublicCalculation';
import UnsavedFeedback from './components/UnsavedFeedback';
import Strumenti from './pages/Strumenti';
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './HomePage';
import SchedePage from './pages/schede';
import Rubrica, { ContattoDetail } from './pages/Rubrica';
import NuovaRCA from './pages/NuovaRCA';
import Agenda from './pages/Agenda';
import Esportazioni from './pages/Esportazioni';
import SiteNav from './components/SiteNav';
import Accesso, { ImpostazioniAccessi } from './pages/Accesso';
import { autoFormatOnBlur } from './utils/autoFormat';
import Sospeso from './pages/Sospeso';


import './App.css';

function AppContent({ operator, onLogout }) {
  const { pathname } = useLocation();
  const showSiteNav = pathname === '/' || pathname === '/schede' || pathname.startsWith('/contatti') ||
    pathname === '/agenda' || pathname === '/esportazioni' || pathname === '/impostazioni' || pathname.startsWith('/strumenti');
  return (
    <>
      <UnsavedFeedback />
      {showSiteNav && <SiteNav operator={operator} onLogout={onLogout} />}
      <div className={showSiteNav ? 'site-nav-content' : undefined} onBlurCapture={autoFormatOnBlur}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/schede" element={<SchedePage operator={operator} />} />
        <Route path="/in-sospeso/:id" element={<Sospeso operator={operator} onLogout={onLogout} />} />
        <Route path="/contatti" element={<Rubrica />} />
        <Route path="/contatti/:id" element={<ContattoDetail />} />
        <Route path="/agenda" element={<Agenda operator={operator} />} />
        <Route path="/esportazioni" element={<Esportazioni />} />
        <Route path="/strumenti/*" element={<Strumenti />} />
        <Route path="/impostazioni" element={<ImpostazioniAccessi operator={operator} />} />
        
        {/* Rotte per le schede con supporto a ID */}
        <Route path="/nuova-rca/:id?" element={<NuovaRCA operator={operator} onLogout={onLogout} />} />
        <Route path="/conducente/:id?" element={<NuovaRCA tipo="Conducente" operator={operator} onLogout={onLogout} />} />
        <Route path="/trasportato/:id?" element={<NuovaRCA tipo="Trasportato" operator={operator} onLogout={onLogout} />} />
        <Route path="/pedone/:id?" element={<NuovaRCA tipo="Pedone" operator={operator} onLogout={onLogout} />} />
        <Route path="/bicicletta/:id?" element={<NuovaRCA tipo="Bici" operator={operator} onLogout={onLogout} />} />
        <Route path="/auto/:id?" element={<NuovaRCA tipo="Auto" operator={operator} onLogout={onLogout} />} />
        <Route path="/infortunio-sul-lavoro/:id?" element={<NuovaRCA tipo="Infortunio sul lavoro" operator={operator} onLogout={onLogout} />} />
        <Route path="/rc-diversi/:id?" element={<NuovaRCA tipo="RC diversi" operator={operator} onLogout={onLogout} />} />
        <Route path="/rivalsa-ditta/:id?" element={<NuovaRCA tipo="Rivalsa Ditta" operator={operator} onLogout={onLogout} />} />
        <Route path="/rc-professionale/:id?" element={<NuovaRCA tipo="RC professionale" operator={operator} onLogout={onLogout} />} />
        <Route path="/polizza-infortuni/:id?" element={<NuovaRCA tipo="Polizza infortuni" operator={operator} onLogout={onLogout} />} />
        <Route path="/pratica/:id" element={<NuovaRCA operator={operator} onLogout={onLogout} />} />
        

      </Routes>
      </div>
    </>
  );
}

function AuthenticatedApp() {
  const [auth, setAuth] = React.useState({ loading: true, operator: null, setupRequired: false });
  React.useEffect(() => {
    let active = true;
    const check = async () => {
      try {
        const response = await fetch('/api/auth/me');
        const data = await response.json();
        if (active) setAuth({ loading: false, operator: response.ok ? data.operator : null, setupRequired: !!data.setupRequired });
      } catch {
        if (active) setAuth({ loading: false, operator: null, setupRequired: false });
      }
    };
    check();
    window.addEventListener('focus', check);
    return () => { active = false; window.removeEventListener('focus', check); };
  }, []);
  const logout = async () => {
    await fetch('/api/auth/logout', { method: 'POST' }).catch(() => {});
    setAuth({ loading: false, operator: null, setupRequired: false });
  };
  return (
    <>
      {auth.loading ? <main className="accesso-page">Caricamento CISA…</main> :
        auth.operator ? <AppContent operator={auth.operator} onLogout={logout} /> :
        <Accesso setupRequired={auth.setupRequired} onAccess={operator => setAuth({ loading: false, operator, setupRequired: false })} />}
    </>
  );
}

function Entry(){const {pathname}=useLocation();return pathname.replace(/\/$/,'')==='/calcolo-danno-biologico-cis'?<CisCalculation/>:pathname.replace(/\/$/,'')==='/calcolo-risarcimento'?<PublicCalculation/>:<AuthenticatedApp/>;}
function App(){return <Router><Entry/></Router>;}
export default App;
